import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MarkMailAsTakeInChargeRequestParams } from 'src/app/shared/models/iCourrier/take-in-charge/prise-en-charge';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MailsTakeChargeService {
  private iCourrierURL;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iCourrierURL = config.apiICourrierBaseUrl;
  }

  public markAsTakeInCharge(id: number, data: MarkMailAsTakeInChargeRequestParams): Observable<void> {
    return this.http.put<void>(`${this.iCourrierURL}/Mails/${id}/MarkAPrendreEnCharge`, data);
  }

  public markAsTakeInChargeCollective(id: number): Observable<void> {
    return this.http.put<void>(`${this.iCourrierURL}/Mails/${id}/PrendreEnChargeCollective`, {});
  }

  public markAsTakeInChargeExclusive(id: number): Observable<void> {
    return this.http.put<void>(`${this.iCourrierURL}/Mails/${id}/PrendreEnChargeExclusive`, {});
  }

  public refuseTakeInCharge(id: number): Observable<void> {
    return this.http.put<void>(`${this.iCourrierURL}/Mails/${id}/RefusePrendreEnCharge`, {});
  }

  public cancelTakeInCharge(id: number): Observable<void> {
    return this.http.put<void>(`${this.iCourrierURL}/Mails/${id}/AnnulePrendreEnCharge`, {});
  }

  public closeTakeInCharge(id: number): Observable<void> {
    return this.http.put<void>(`${this.iCourrierURL}/Mails/${id}/CloturePrendreEnCharge`, {});
  }
}
